import React from "react";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import { PHONE, PHONE_LINK } from "./contactInfo";

function CtaBand() {
  return (
    <section className="dm-section-tight">
      <div className="dm-container">
        <div className="dm-cta">
          <div>
            <h2 className="dm-h2">Tell us about your doors and windows</h2>
            <p>
              Share your requirement and we will get back to you with the right screen
              and a quote.
            </p>
          </div>
          <div className="dm-cta-actions">
            <Link to="/contactus" className="dm-btn dm-btn-light">
              Send an enquiry
            </Link>
            <a href={PHONE_LINK} className="dm-btn dm-btn-ghost-light">
              <CallIcon /> {PHONE}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBand;
